"use client";

import { InputOTP, InputOTPGroup, InputOTPSlot, InputOTPSeparator } from "@src/components/ui/input-otp";
import { useState } from "react";
import { useSupabase } from "../../_components/providers/supabase-provider";
import { toast } from "sonner";
import { EmailOtpType } from "@supabase/supabase-js";
import { useRouter } from "next/navigation";
import { LoadingSpinner } from "@src/components/tw/loading-spinner";
import { posthog, AnalyticsEvent } from "@src/analytics";
export type OTPFormProps = {
  email: string;
  redirect: string;
  type: EmailOtpType;
};
export const OTPForm = ({
  email,
  redirect,
  type
}: OTPFormProps) => {
  const [token, setToken] = useState<string | null>(null);
  const [verifyingToken, setVerifyingToken] = useState<boolean>(false);
  const {
    supabase
  } = useSupabase();
  const router = useRouter();
  const verifyToken = async () => {
    if (!token) {
      throw new Error("OTP is not set");
    }
    if (token.length !== 6) {
      throw new Error("OTP is not 6 digits");
    }
    setVerifyingToken(true);
    const {
      error
    } = await supabase.auth.verifyOtp({
      email,
      type,
      token
    });
    if (error) {
      toast.error(error.message, {
        duration: 5000
      });
      setVerifyingToken(false);
    } else {
      posthog.capture(AnalyticsEvent.USER_SIGNED_IN, {
        method: "otp"
      });
      router.push(redirect);
    }
  };
  return <div className="flex justify-center h-16 items-center" data-sentry-component="OTPForm" data-sentry-source-file="otp-form.tsx">
      {verifyingToken ? <LoadingSpinner className="size-8" /> : <InputOTP maxLength={6} onChange={setToken} onComplete={verifyToken} containerClassName="justify-center" disabled={verifyingToken}>
          <InputOTPGroup>
            <InputOTPSlot index={0} />
            <InputOTPSlot index={1} />
            <InputOTPSlot index={2} />
          </InputOTPGroup>
          <InputOTPSeparator />
          <InputOTPGroup>
            <InputOTPSlot index={3} />
            <InputOTPSlot index={4} />
            <InputOTPSlot index={5} />
          </InputOTPGroup>
        </InputOTP>}
    </div>;
};